import React, { useEffect, useState } from 'react';
const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ejvZjbNWsqtphwczAQ67mx/ChatGPT_Image_Apr_17%2C_2025%2C_09_45_26_PM.png',
    alt: 'Productos promocionales Guaterflow'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/43BrafduGnXsSjfvkN4b7s/UNIDAD_DE_DISTRIBUCION.png',
    alt: 'Unidad de distribución Guaterflow'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vAEdAgpZxXi2APnpfHR9Mo/ChatGPT_Image_Apr_17%2C_2025%2C_11_47_22_PM.png',
    alt: 'Expendedora Guaterflow'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3iT3uBypchybi7JmK8SPKE/TUMBLERS.png',
    alt: 'Tumblers Guaterflow'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative w-full h-full" data-id="element-17">
      {images.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-18">
          <img src={image.url} alt={image.alt} className="w-full h-full object-contain rounded-lg" data-id="element-19" />
        </div>)}
      <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2 z-10" data-id="element-20">
        {images.map((_, index) => <button key={index} className={`w-2 h-2 rounded-full transition-colors ${index === currentIndex ? 'bg-[#2d98e2]' : 'bg-gray-300'}`} onClick={() => setCurrentIndex(index)} data-id="element-21" />)}
      </div>
    </div>;
};
export default Carousel;